'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _process$env$NODE_ENV = process.env.NODE_ENV,
    NODE_ENV = _process$env$NODE_ENV === undefined ? 'development' : _process$env$NODE_ENV;
var onRouteUpdate = exports.onRouteUpdate = function onRouteUpdate(_ref) {
  var location = _ref.location;

  if (!window.analytics || typeof window.analytics.page !== 'function') {
    if (NODE_ENV === 'development') {
      console.warn('Unable to locate analytics.js');
    }
    return;
  }

  window.analytics.page();
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-segment/gatsby-browser.js
// module id = ./node_modules/gatsby-plugin-segment/gatsby-browser.js
// module chunks = 231608221292675